<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{data.message}}</h4>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body col-12">
    <form [formGroup]="referenceDeviceForm">
        <div class="row">

            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="calibrationDate">{{data.isMeasurementValue ? 'Ara Kontrol Tarihi' : 'Kal. Tarihi'}}</label>
                <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" [setDate]="date"
                    formControlName="calibrationDate"></ng2-flatpickr>
                <div *ngIf="referenceDeviceForm.get('calibrationDate').invalid && referenceDeviceForm.get('calibrationDate').touched"
                    class="text-danger">
                    <small *ngIf="referenceDeviceForm.get('calibrationDate').hasError('required')">Kalibrasyon tarihi
                        zorunludur.</small>
                </div>
            </div>

            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="futureCalibrationDate">{{data.isMeasurementValue ? 'Gelecek Ara Kntrl Tarihi' :'Gelecek Kal.
                    Tarihi' }}</label>
                <ng2-flatpickr [config]="dateTimeStartOptions" name="dateTime" [setDate]="date2"
                    formControlName="futureCalibrationDate"></ng2-flatpickr>
                <div *ngIf="referenceDeviceForm.get('futureCalibrationDate').invalid && referenceDeviceForm.get('futureCalibrationDate').touched"
                    class="text-danger">
                    <small *ngIf="referenceDeviceForm.get('futureCalibrationDate').hasError('required')">Gelecek
                        kalibrasyon tarihi zorunludur.</small>
                </div>
            </div>
            
            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="traceability">{{data.isMeasurementValue ? 'Yetkili' : 'İzlenebilirlik'}}</label>
                <input type="text" class="form-control" maxlength="30" formControlName="traceability" />
                <div *ngIf="referenceDeviceForm.get('traceability').invalid && referenceDeviceForm.get('traceability').touched"
                    class="text-danger">
                    <small *ngIf="referenceDeviceForm.get('traceability').hasError('required')">
                        {{data.isMeasurementValue ? 'Yetkili' : 'İzlenebilirlik'}} zorunludur.</small>
                    <small *ngIf="referenceDeviceForm.get('traceability').hasError('maxlength')">Maksimum 30 karakter
                        girilebilir.</small>
                </div>
            </div>

            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="certificateNo">Sertfika No</label>
                <input type="text" class="form-control" maxlength="30" formControlName="certificateNo" />
                <div *ngIf="referenceDeviceForm.get('certificateNo').invalid && referenceDeviceForm.get('certificateNo').touched"
                    class="text-danger">
                    <small *ngIf="referenceDeviceForm.get('certificateNo').hasError('required')">Sertfika No
                        zorunludur.</small>
                    <small *ngIf="referenceDeviceForm.get('certificateNo').hasError('maxlength')">Maksimum 20 karakter
                        girilebilir.</small>
                </div>
            </div>

            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="acceptanceCriterion">Kabul Kriteri</label>
                <input type="text" class="form-control" maxlength="30" formControlName="acceptanceCriterion" />
                <div *ngIf="referenceDeviceForm.get('acceptanceCriterion').invalid && referenceDeviceForm.get('acceptanceCriterion').touched"
                    class="text-danger">
                    <small *ngIf="referenceDeviceForm.get('acceptanceCriterion').hasError('required')">Kabul Kriteri
                        zorunludur.</small>
                    <small *ngIf="referenceDeviceForm.get('acceptanceCriterion').hasError('maxlength')">Maksimum 30
                        karakter girilebilir.</small>
                </div>
            </div>

            <div class="col-xl-6 col-md-6 col-sm-12">
                <label for="calibrationCertificateUncertainty">Kal. Sertf. Belirsizliği</label>
                <input type="text" class="form-control" maxlength="30"
                    formControlName="calibrationCertificateUncertainty" />
                <div *ngIf="referenceDeviceForm.get('calibrationCertificateUncertainty').invalid && referenceDeviceForm.get('calibrationCertificateUncertainty').touched"
                    class="text-danger">
                    <small
                        *ngIf="referenceDeviceForm.get('calibrationCertificateUncertainty').hasError('required')">Kal.
                        Sertf. Belirsizliği zorunludur.</small>
                    <small
                        *ngIf="referenceDeviceForm.get('calibrationCertificateUncertainty').hasError('maxlength')">Maksimum
                        30 karakter girilebilir.</small>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="data.isMeasurementValue">
            <div class="col-xl-4 col-md-6 col-sm-12">
                <label for="nominalValue">Nominal Değer</label>
                <input type="number" class="form-control" formControlName="nominalValue" />
                <div *ngIf="referenceDeviceForm.get('nominalValue').invalid && referenceDeviceForm.get('nominalValue').touched"
                    class="text-danger">
                    <small>Nominal değer zorunludur.</small>
                </div>
            </div>

            <div class="col-xl-4 col-md-6 col-sm-12">
                <label for="measuredValue">Ölçülen Değer</label>
                <input type="number" class="form-control" formControlName="measuredValue" />
                <div *ngIf="referenceDeviceForm.get('measuredValue').invalid && referenceDeviceForm.get('measuredValue').touched"
                    class="text-danger">
                    <small>Ölçülen değer zorunludur.</small>
                </div>
            </div>

            <div class="col-xl-4 col-md-6 col-sm-12">
                <label for="tolerance">Tolarans</label>
                <input type="number" class="form-control" formControlName="tolerance" />
                <div *ngIf="referenceDeviceForm.get('tolerance').invalid && referenceDeviceForm.get('tolerance').touched"
                    class="text-danger">
                    <small>Tolarans değer zorunludur.</small>
                </div>
            </div>
        </div>
    </form>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-danger" rippleEffect (click)="closeModal()">İptal</button>
    <button type="button" class="btn btn-success" rippleEffect (click)="onSumbit()"
        [disabled]="referenceDeviceForm.invalid">Kaydet</button>
</div>